import { useEffect } from 'react';

import { useAuthContext } from '../context';

export function useSentryPersonalization(Sentry: any) {
	const auth = useAuthContext();

	useEffect(() => {
		if (auth.account) {
			Sentry.setUser({ id: `${auth.account.id}` });
		} else {
			Sentry.setUser(null);
		}
	}, [auth.account]);
}
